import {
  BaSeDialogContext,
  BaSeLoading,
  BaSeMessage,
} from '@base/react';
import React from 'react';
import * as Sebrae from '@sebrae/react-core';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/moxer.css';
import 'codemirror/theme/neo.css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import { useUtilsService } from '../../hooks/utils';
import { CERTIFICADO_TEMPLATE } from '../../hooks/constants';
import { ContentViewerPdf } from './template-certificados-styled';

const ViewTemplate = ({
  variables,
  dtoTemplate,
  codeHtml,
  isTabActive,
  setIsTabActive,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [loading, setLoading] = React.useState(false);
  const [pdfData, setPdfData] = React.useState(null);
  const [heigthPdf, setHeigthPdf] = React.useState(1);

  const { isNotEmpty, formatJson } = useUtilsService();
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { backendPostBlob } = Sebrae.useBackend();

  const blobToText = React.useCallback(async (blob) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const regex = /\bCount\b\s+(\w+)/g;
      let match;
      while ((match = regex.exec(result)) !== null) {
        setHeigthPdf(match[1]);
      }
    };
    reader.onerror = (error) => {
      console.error('Erro ao ler o Blob:', error);
    };
    await reader.readAsText(blob);
  },[]);

  const handleShowTemplate = React.useCallback(
    (formData) => {
      setLoading(true);
      setIsTabActive(true);
      backendPostBlob(`${CERTIFICADO_TEMPLATE}/visualizacao`, formData)
        .then((blob) => {
          blobToText(blob);
          const url = URL.createObjectURL(blob);
          setPdfData(url);
        })
        .catch((erro) => {
          console.log('error: ', erro);
          showNotification({
            message: 'Não foi possível gerar a visualização!',
            supportMessage: erro?.message ?? '',
            color: 'destructive',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [backendPostBlob, blobToText, setIsTabActive, showNotification],
  );

  const listEmpty = React.useMemo(() => {
    return variables?.filter((item) => !isNotEmpty(item.valor));
  }, [isNotEmpty, variables]);

  const isPlural = React.useMemo(() => listEmpty.length > 1, [listEmpty]);

  const messageEmpty = React.useCallback(() => {
    let messageVar = [];
    if (!!listEmpty.length) {
      listEmpty.map((item) => messageVar.push(item.chave));
    }
    return (
      <>
        {`A${isPlural ? 's' : ''} variáve${isPlural ? 'is' : 'l'}`}{' '}
        <strong style={{ fontStyle: 'italic' }}>
          {` ${messageVar.join(', ').replace(/,([^,]*)$/, ' e$1 ')}`}
        </strong>{' '}
        {` est${isPlural ? 'ão' : 'á'} sem exemplo de preenchimento`}
      </>
    );
  }, [isPlural, listEmpty]);

  React.useEffect(() => {
    const itemVariable = variables.map((variable) => ({
      [variable.chave]: variable.valor,
    }));
    let formData = dtoTemplate;
    formData.variaveis = formatJson(itemVariable);
    formData.htmlCertificado = codeHtml;
    if (!isTabActive) handleShowTemplate(formData);
  }, [
    codeHtml,
    dtoTemplate,
    formatJson,
    handleShowTemplate,
    isNotEmpty,
    isTabActive,
    listEmpty,
    messageEmpty,
    showNotification,
    variables,
  ]);

  return (
    <ContentViewerPdf>
      {!!listEmpty.length && (
        <div style={{ margin: '16px 0' }}>
          <BaSeMessage
            color="destructive"
            title="Atenção!"
            message={messageEmpty()}
            onAction={function noRefCheck() {}}
          />
        </div>
      )}
      {loading ? (
        <BaSeLoading />
      ) : (
        pdfData && (
          <iframe
            title="Visualizar Template Certificado"
            src={pdfData}
            width="100%"
            height={`${parseInt(heigthPdf) > 1 ? parseInt(heigthPdf) * 845 : 880}px`}
          />
        )
      )}
    </ContentViewerPdf>
  );
};

export { ViewTemplate as default };
